import React, { memo } from 'react';
import { Route, Switch } from 'react-router-dom';
import WarehouseReleaseDetails from 'containers/WarehouseReleases/WarehouseReleaseDetails/WarehouseReleaseDetails';
import WarehouseReleasesDashboard from 'containers/WarehouseReleases/WarehouseReleasesDashboard';
function WarehouseReleases({ url }) {
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: `${url}` },
            React.createElement(WarehouseReleasesDashboard, null)),
        React.createElement(Route, { path: `${url}/:warehouseReleaseId` },
            React.createElement(WarehouseReleaseDetails, null))));
}
export default memo(WarehouseReleases);
